import {JOB_COMPLETED_STATES, JOB_STATE_DRAFT} from "../const/job.const";
import JobFeedback from "./JobFeedback";
import {createUUID4} from "../../../../../helper/uuid";
import Canvas from "./Canvas";

export default class StageJob {
    id = '';
    state = JOB_STATE_DRAFT;
    sysJobs = [];
    mainJob = null;
    canvas = null;
    previewCanvas = null;
    exportCanvas = null;
    preview = false;
    activeStep = 'upload';

    settings = {
        prompt: '',
        inpainting_fill: 'original',
        inpainting_area: 'whole_picture',
        mask_mode: 'inpaint_masked',
        inpainting_area_padding: 32,
        mask_blur: 10,
        cfg_scale: 7,
        style: 'inpainting_generic_1',
        num_inference_steps: 20,
        denoising_strength: 0.75
    };
    layout = {
        sidebar_left: false,
        sidebar_right: false,
        nav_secondary: false,
        sidebar_bot: false,
    }

    constructor() {
        this.id = createUUID4();
        this.feedback = new JobFeedback();
        this.canvas = new Canvas();
        this.previewCanvas = new Canvas();
        this.exportCanvas = new Canvas();
    }

    isStateCompleted() {
        return JOB_COMPLETED_STATES.includes(this.state);
    }
}
